// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .google-button {
  background-color: #d3d3d3;
  color: black;
  width: 191px;
  height: 46px;
}
:host .google-button:hover {
  background-color: #c4c4c4;
  color: black;
  width: 191px;
  height: 46px;
}
:host .facebook-button {
  background-color: #d3d3d3;
  color: black;
  width: 191px;
  height: 46px;
  background-size: contain;
}
:host .facebook-button:hover {
  background-color: #c4c4c4;
  color: black;
  width: 191px;
  height: 46px;
  background-size: contain;
}
:host .socialButton-customizable, :host .socialButton-customizable:hover {
  height: 35px;
  text-align: center;
  width: 49%;
  margin-bottom: 5px;
  margin-left: 25%;
}
:host .social-logo {
  width: 35px;
  height: 100%;
  text-align: center;
  padding-right: 10px;
  display: inline-block;
  vertical-align: middle;
}
:host .facebook-button {
  background-color: #4267b2;
  color: white;
}
:host .facebook-button:hover {
  background-color: #2955ad;
  color: white;
}
:host .google-button {
  background-color: #d3d3d3;
  color: black;
}
:host .google-button:hover {
  background-color: #c4c4c4;
  color: black;
}
:host .idpDescription-customizable {
  padding-top: 10px;
  padding-bottom: 10px;
  display: block;
  font-size: 16px;
  text-align: center;
}
:host .legalText-customizable {
  color: #747474;
  font-size: 11px;
  text-align: center;
}
:host .textDescription-customizable {
  padding-top: 10px;
  padding-bottom: 10px;
  display: block;
  font-size: 16px;
  text-align: center;
}
:host .banner-customizable {
  padding: 10px 0px 10px 0px;
  background-color: white;
  text-align: center;
}
:host .login-or {
  position: relative;
  font-size: 16px;
  padding-top: 7px;
  padding-bottom: 7px;
  margin-top: 8px;
}
:host .hr-or {
  color: #cdcdcd;
  background-color: #ffcc00;
  height: 1px;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
:host .span-or {
  display: block;
  position: absolute;
  left: 50%;
  top: -2px;
  margin-left: -25px;
  background-color: #fff;
  text-align: center;
  padding: 0px 5px 0px 5px;
  color: #ffcc00;
}
:host .signin-button {
  text-align: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
